import React from "react";
import RelevantLinkBlock from "../fragments/RelevantLinkBlock";
import {Link} from "react-router-dom";

export default function Article5() {

    let relevantUrls = ["/listing", "/vehicleOrder/catalog?vehicleCategory=CHN_ORDER", "/vehicleOrder/pricing", "/loan"];

    return (
        <div className="site-section">
            <div className="container">
                <div className="row">
                    <div className="col-md-7 blog-content ml-auto order-lg-1">
                        <h2>Что сейчас продаётся на рынке автомобилей после летних "бурных" продаж?</h2>

                        <img src="/pictures/blog/1617.jpg" className="img-fluid py-2" alt="Автоплощадка"/>
                        <p>Рынок автомобилей в Беларуси в этом году испытал значительные преобразования: наличие новых
                            китайских марок, закрытие границы с Литвой и высокий спрос на автомобили. Это оказало
                            влияние на вторичный рынок автомобилей. Несмотря на высокие цены, спрос остается. Сейчас
                            доступны различные программы финансирования, которые активно используются покупателями.
                        </p>
                        <p>Директор компании «БелАвтоЭксперт» отмечает, что после летнего пика спроса на экономичные
                            седаны типа Polo и Rio, осенью покупатели обращают внимание на кроссоверы и универсалы. Цены
                            в целом остались стабильными, однако продавцы часто уступают в цене.
                        </p>
                        <img src="/pictures/blog/4399.jpeg" className="img-fluid py-2" alt="Автоплощадка"/>
                        <p>Примерно 80% сделок на площадке осуществляется с привлечением финансирования. Это кредиты и
                            лизинги.
                            В настоящее время достаточно легко найти <Link to="/loan">удобный и выгодный вариант
                                финансирования.</Link></p>
                        <p>Сейчас компания <Link to="https://ringoleasing.by">Ringo</Link> по промокоду «Лизинговые
                            каникулы в Ringo» даёт возможность купить <Link to="/listing">любой автомобиль</Link> с
                            отсрочкой платежей в 2 месяца. Оформите договор лизинга до 15 ноября, а вносите платежи
                            только в 2025 году. Первоначальный взнос в размере от 10% стоимости выбранного авто. Срок
                            лизинга до 5 лет.
                        </p>
                        <p>В нашем автосалоне представлено множество вариантов как новых, так и <Link to="/listing">автомобилей
                            с пробегом</Link>.
                            Также есть возможность заказать <Link to="/vehicleOrder/catalog">новое авто из Китая</Link>
                        </p>
                        <p>Таким образом, несмотря на меняющиеся условия рынка, благодаря <Link to="/loan">разным
                            программам финансирования</Link>, белорусы продолжают находить для себя интересные варианты
                            как на вторичном рынке, так и на рынке новых авто.
                        </p>
                        <p><Link to="https://av.by/news/rn_zhivyye_avto_s_probegom_v_lizing">Полная версия статьи на av.by</Link>.</p>

                        <img src="/building_main.JPEG" className="img-fluid py-2" alt="Responsive image"/>
                    </div>

                    <div className="col-lg-4 order-lg-2">
                    <RelevantLinkBlock relevantUrls={relevantUrls}/>
                    </div>

                </div>
            </div>
        </div>

    );

}
